import * as React from 'react';

import classnames from 'classnames';

import {Stack} from 'shells/layout/stack/stack';
import {LoadingText} from 'shells/loading-placeholder/loading-text';
import {Body} from 'shells/typography/body';

import {AccentBorder} from '../../accent-border/accent-border';
import {RemoveButton} from '../../button/remove-button/remove-button';
import {Card} from '../../card/card';
import {colors} from '../../colors/colors';

type Props = {
    name: string;
    onRemove?: () => void;
    isLoading?: boolean;
    borderColor?: string;
    onClick?: () => void;
    isDisabled?: boolean;
};

export function SelectedFieldCard(props: Props) {
    const classNames = classnames('pad-4', {
        disabled: props.isDisabled,
    });

    return (
        <div className='pb-8'>
            <Card hasBorder={true} onClick={props.onClick}>
                <AccentBorder location='left' color={props.borderColor || colors.lead}>
                    <div className={classNames}>
                        <Stack
                            isHorizontal={true}
                            alignItems='center'
                            justifyContent='space-between'
                        >
                            {props.isLoading ? (
                                <LoadingText height={15} />
                            ) : (
                                <>
                                    <Body size='tiny'>{props.name}</Body>
                                    {props.onRemove ? (
                                        <RemoveButton
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                // @ts-expect-error
                                                props.onRemove();
                                            }}
                                            size={12}
                                        />
                                    ) : null}
                                </>
                            )}
                        </Stack>
                    </div>
                </AccentBorder>
            </Card>
        </div>
    );
}
